import { UserProfile } from "oidc-client-ts";
import { useMe } from "../hooks/useMe";

export {
  MANAGEMENT_ROLES,
  normalizeManagementRole,
} from "../constants/managementRoles";
export type { ManagementRole } from "../constants/managementRoles";

export interface AuthProfile extends UserProfile {
  company_roles: string[];
  allowed_company_ids: string[];
  company_id: string;
  email: string;
  username: string;
  email_verified: boolean;
  enabled: boolean;
  locale: "en" | "de";
  first_name?: string;
  last_name?: string;
  name?: string;
  management_roles: string[];
}

export function useAuthProfile() {
  const { data } = useMe();

  if (!data) return null;

  return data;
}
